import React from 'react';
import { ProductInformationSliderContainer } from 'Components/widgets/product-information-slider/ProductInformationSlider.container';
import type { TeaserCardProps } from './teaser-cards-card/TeaserCardsCard';
import { TeaserCardsCard } from './teaser-cards-card/TeaserCardsCard';
import { TeaserCardsLayer } from './teaser-cards-layer/TeaserCardsLayer';
type CardProps = TeaserCardProps & {
  layerBlocks?: Array<any>;
  layerDescription?: string;
  layerTitle?: string;
  link: {
    onClick?: () => void;
    url?: string;
  };
};
export const resolveLayerData = (cardData: CardProps) => {
  const { image, layerTitle: title, layerDescription: description, layerBlocks: blocks } = cardData;
  return Promise.resolve({
    blocks,
    description,
    image,
    title,
  });
};
type Props = {
  backNavigationLabel: string;
  cards: Array<CardProps>;
  scrollBackwardLabel: string;
  scrollForwardLabel: string;
  sliderQueryName: string;
};
export const TeaserCards = ({
  backNavigationLabel,
  cards = [],
  scrollBackwardLabel,
  scrollForwardLabel,
  sliderQueryName,
}: Props) => {
  return (
    <ProductInformationSliderContainer
      backNavigationLabel={backNavigationLabel}
      isExpanded
      queryLayer={sliderQueryName}
      renderDetail={(layerData) => <TeaserCardsLayer {...layerData} />}
      scrollBackwardLabel={scrollBackwardLabel}
      scrollForwardLabel={scrollForwardLabel}
      sliderIndex={1}
    >
      {cards.map((card, index) => (
        <TeaserCardsCard
          card={card}
          fetchDetail={() => resolveLayerData(card)}
          key={card.title || index}
          link={card.link} // Component takes card link as separate prop so it can be cloned with a slider link
        />
      ))}
    </ProductInformationSliderContainer>
  );
};
